import { getEnvValue } from "@novalabsxyz/utils/env";
import { yup } from "@novalabsxyz/utils/yup";

export const StoreConfig = {
  Logger: {
    Disabled: getEnvValue("PUBLIC_STORE_LOGGER_DISABLED", yup.boolean().required().default(false)),
    Enabled: getEnvValue("PUBLIC_STORE_LOGGER_ENABLED", yup.boolean().required().default(false)),
  },
};
